import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmActionData } from '@rma/dashboard/generic/ui/confirm-action-modal';
import { RmaModalService } from '@rma/dashboard/generic/ui/modal';
import { map, of, switchMap, take } from 'rxjs';
import { DirtyComponent } from './dirty.component';

const defaults: ConfirmActionData<boolean> = {
  title: 'Unsaved Changes?',
  message: 'You have unsaved changes are you sure you want to leave?',
  buttonText: 'Yes',
  useTranslation: false,
  onConfirm: () => of(true),
};

export const dirtyCheckGuard = (
  config: Partial<Omit<ConfirmActionData<boolean>, 'onConfirm'>> = defaults,
): CanDeactivateFn<DirtyComponent> => {
  return (component: DirtyComponent) => {
    const rmaModalService = inject(RmaModalService);

    const dirty$ = component.isDirty$;

    if (!dirty$) {
      console.warn('can not find isDirty$ in', component);
      return of(true);
    }

    return dirty$.pipe(
      switchMap((isDirty) => {
        if ((isDirty ?? false) === false) {
          return of(true);
        }

        return rmaModalService
          .openConfirmAction({
            ...defaults,
            ...config,
          })
          .afterClosed()
          .pipe(map((x) => x ?? false));
      }),
      take(1),
    );
  };
};
